module.exports = __webpack_public_path__ + "media/images/pc/stores/nagoya/access/nagoya_point4_1-d0f749ce017184560cbcd517c3db7071.jpg";